import React from 'react';
import PropTypes from 'prop-types';

import RichText from '../RichText/RichText';
import { vercel_base_url } from '../../util/config';
import RichTextPropTypes from '../../prop-types/rich-text';
import { BUILD } from '../../util/const';

import * as Styled from './BuyAgainCard.styled';

/**
 * Buy Again Card with rich text content and button copies pulled from Contentful
 */
const BuyAgainCard = ({ richTextContent, buttonCopy, className }) => {
  const base_url = BUILD === 'shopify' ? vercel_base_url : '';

  return (
    <Styled.BuyAgainCard className={className}>
      <RichText richText={richTextContent} />
      <Styled.BuyAgainLink
        href={`${base_url}/buy-again`}
        as={BUILD === 'shopify' && 'a'}
      >
        <Styled.ButtonIcon isFull>{buttonCopy}</Styled.ButtonIcon>
      </Styled.BuyAgainLink>
    </Styled.BuyAgainCard>
  );
};

BuyAgainCard.propTypes = {
  /**
   * Rich text content
   */
  richTextContent: PropTypes.shape(RichTextPropTypes),
  /**
   * Buy again card button text
   */
  buttonCopy: PropTypes.string,
  className: PropTypes.string
};

BuyAgainCard.defaultProps = {
  richTextContent: null,
  buttonCopy: '',
  className: undefined
};

export default BuyAgainCard;
